import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import Sectors from './Sectors';

async function action({ store, largeProjectsEnabled }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  // LARGE PROJECTS FLAG: when OFF this admin LP route is unreachable -> redirect home.
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title: 'Sectors — Big Projects',
    component: (
      <AdminLayout>
        <Sectors />
      </AdminLayout>
    ),
  };
}

export default action;
